import BrowseByCategoryOffers from 'features/rewards/categoriesV2/BrowseByCategoryOffers/BrowseByCategoryOffers';
import React from 'react';

export default function Page() {
  return <BrowseByCategoryOffers />;
}
